const lbaNav = angular.module('app.lbaNav', []);

lbaNav.controller('lbaNavCtrl', require('./lbaNavCtrl'));
lbaNav.directive('lbaNav', require('./lbaNavDir'));

export default lbaNav;



// WEBPACK FOOTER //
// ./src/components/lbaNav/index.js